import { render, staticRenderFns } from "./productCard.vue?vue&type=template&id=b2d9f4bc"
import script from "./productCard.vue?vue&type=script&lang=js"
export * from "./productCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports